.spellListPlaceholder {
  background: var(--color-bg-white);
  border-radius: 2px;
  padding: 8px 16px;
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;

  .placeholderIcon {
    fill: var(--color-text);
    width: 24px;
    height: 24px;
    display: inline-block;
    vertical-align: bottom;
  }
}

.spellListHeader {
  margin: 0;
}

.spellListsHeader {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.badgeList {
  display: flex;
  gap: inherit;
  flex-wrap: wrap;
}

.spellCount {
  font-family: sans-serif;
  background: var(--color-accent);
  border-radius: 20px;
  color: #fff;
  font-size: 14px;
  font-weight: normal;
  display: flex;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;

  &.warning {
    background: var(--color-warning);
  }

  &:has(svg) {
    padding-left: 4px;
    padding-right: 16px;
  }

  > svg {
    display: inline-block;
    fill: #fff;
    height: 20px;
    width: 20px;
  }
}
